import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=caa984c4&scoped=true&"
import script from "./Publish.vue?vue&type=script&lang=js&"
export * from "./Publish.vue?vue&type=script&lang=js&"
import style0 from "./Publish.vue?vue&type=style&index=0&id=caa984c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa984c4",
  null
  
)

export default component.exports